var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-default',[_c('article',{staticClass:"content container template template--navbar-fixed template--content"},[_c('h1',[_vm._v(" Assess.vue ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }